// extracted by mini-css-extract-plugin
export default {"Img":"StatusOk_Img__t+JNS"};